export default __webpack_public_path__ + "static/forguidancetext-789c04b3a11e55d20c1683c7e903b84c.png";